var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcStoreInfoFill = function SvgIcStoreInfoFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.353 4a.5.5 0 0 1 .475.345l1.96 6a.5.5 0 0 1-.476.655h-1.31v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V11h-4v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V11H2.69a.5.5 0 0 1-.476-.655l1.959-6A.5.5 0 0 1 4.65 4z"
  })));
};
export default SvgIcStoreInfoFill;